import { createReducer } from '@reduxjs/toolkit';

const initialState = '';

/**
 * Keeps service plan state
 *
 * @param  {Array} state: the new state
 * @param  {Object} action: action to be performed
 * @return {Object} the new state
 */
const logoAndColor = createReducer(initialState, {
  GET_LOGO_AND_COLOR: (state, { value }) => value.payload,
});

export default logoAndColor;
